module.exports = __webpack_public_path__ + "img/03ceab793dd92fe820fa99bd93751a69.d9223420.webp";